import { Auth } from "./auth";
import { AuthSettings } from "./authSettings";

export class Environment {
  public ApiBaseUrl!: string;
  public GoogleAuthClientId!: string;
  public SignalREndpoint!: string;
  public authSettings!: AuthSettings;

  constructor() {
    this.ApiBaseUrl = "";
    this.SignalREndpoint = "";
    this.authSettings = new AuthSettings();
  }
}
